var path = '/payments/confirmation/confirmation.html';
var html = "<md-card class=has-circle-icon> <md-card-content class=only-buttons> <div layout=row> <h3 data-test-id=accounts_payments_confirmation_success> Your payment is successful </h3> </div> <div layout=row class=user-message layout-align=center data-test-id=accounts_payments_confirmation_message> Thank you. We've sent an email to {{confirm.email}} confirming your order. </div> </md-card-content> <div layout=row layout-align=center> <md-button data-test-id=accounts_payments_confirmation_done class=\"md-primary md-raised\" ng-click=confirm.next()> DONE </md-button> </div> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./payments/confirmation/confirmation.html
// module id = 276
// module chunks = 0